/**
 * FeedbackPassingThresholdType
 */
export enum FeedbackPassingThresholdType {
    SCORE = 'score',
    PERCENTAGE = 'percentage'
}
